export const LANG_STORAGE_KEY = "dblog-lang";
export const SUPPORTED_LANGS = ["en", "am"];

export function getStoredLanguage() {
  try {
    const stored = localStorage.getItem(LANG_STORAGE_KEY);
    if (SUPPORTED_LANGS.includes(stored)) return stored;
  } catch {
    /* ignore */
  }
  return null;
}

export function getBrowserLanguage() {
  if (typeof navigator === "undefined") return null;
  const raw = (navigator.language || navigator.userLanguage || "").toLowerCase();
  if (raw.startsWith("am")) return "am";
  if (raw.startsWith("en")) return "en";
  return null;
}

/** Saved preference → browser (am/en) → English */
export function resolveLanguage() {
  return getStoredLanguage() || getBrowserLanguage() || "en";
}

export function applyLanguage(lang) {
  if (typeof document === "undefined") return;
  const next = SUPPORTED_LANGS.includes(lang) ? lang : "en";
  document.documentElement.lang = next;
}

export function persistLanguage(lang) {
  const next = SUPPORTED_LANGS.includes(lang) ? lang : "en";
  applyLanguage(next);
  try {
    localStorage.setItem(LANG_STORAGE_KEY, next);
  } catch {
    /* ignore */
  }
  return next;
}
